import React from "react";
import { connect } from "react-redux";
import ModalCrearEncuesta from "./modalCrearEncuesta";
import { loadSubMenu, editarPlanMovilidadEncuesta, escogerTiposUsuariosRiesgosPlanMovilidad, handlerTokenEncuesta, openCloseModalEncuestaTrabajadores, onAlertaPlanMovilidad } from "../../actions";
import { compareDateToday, scrollElementToTop, dataLayerTag, porcentajesEncuestasTrabajadores } from "../../functions";
import TextField from "../../../../Shared/fields/TextField";

import apiConfig from "../../../../../config/api";


class EncuestaTrabajadorPlanMovilidad extends React.PureComponent {

  componentDidMount = () => {
    scrollElementToTop("MENU_ETAPAS_PLAN_MOVILIDA");
  }

  onClickOpenModal = () => {
    this.props.dispatch(openCloseModalEncuestaTrabajadores(true, this.props));
  };

  onClickCloseQuestionary = () => {
    if (this.props.cantidadHombresCentro + this.props.cantidadMujeresCentro < 0) {
      this.props.dispatch(onAlertaPlanMovilidad("error", "No se ha definido la cantidad de trabajadores para la sucursal."));
    } else if ( !this.props.fechaCierreEncuestaTrabajador || (compareDateToday(this.props.fechaCierreEncuestaTrabajador) < 0 ) ) {
      this.props.dispatch(onAlertaPlanMovilidad("error", "No se ha definido la fecha de cierre de la encuesta."));
    } else if (
      ((this.props.encuestaHombres / this.props.cantidadHombresCentro) < 0.6
      ||
      (this.props.encuestaMujeres / this.props.cantidadMujeresCentro) < 0.6)
    ) {
      this.props.dispatch(onAlertaPlanMovilidad("error", "No puede cerrar la encuesta, porque aún no cumple el porcentaje mínimo del 60% para hombres y del 60% para mujeres de encuestas de trabajador respondidas por el centro."));
    } else {
       // cierro la encuesta manualmente
      this.props.dispatch(handlerTokenEncuesta(false));
      this.props.dispatch(editarPlanMovilidadEncuesta(
        this.props.idplanMovilidad,
        false, // this.props.habilitarTokenEncuesta,
        this.props.cantidadHombresCentro,
        this.props.cantidadMujeresCentro,
        this.props.fechaCierreEncuestaTrabajador,
      ));
      this.props.dispatch(escogerTiposUsuariosRiesgosPlanMovilidad(this.props.idplanMovilidad));
      this.props.dispatch(onAlertaPlanMovilidad("success", "Encuesta fue cerrada exitosamente."));
      dataLayerTag({
        'etapa': '2',
        'event': 'paso_2_finaliza_encuesta_trabajadores',
        'tipo_encuesta_finalizada': 'normal',
      });
    }
  };

  prepareCopyToClipboard = () => {
    const textField = document.getElementById("url_encuesta_trabajador").querySelector("input");
    this.copyToClipboard(textField.value);
  };

  copyToClipboard = (value) => {
    const textArea = document.createElement("textarea");
    textArea.value = value;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      const successful = document.execCommand("copy");
      if (successful) {
        this.props.dispatch(onAlertaPlanMovilidad("success", "Se copió la url de la encuesta de trabajador correctamente."));
      }
    } catch (err) {
      this.props.dispatch(onAlertaPlanMovilidad("error", "Ocurrió un error inesperado, no pudo copiarse la url"));
    }
    document.body.removeChild(textArea);
  };

  render() {
    return (
      <section id="encuesta-trabajador-main">
        <ModalCrearEncuesta />
        <div className="container-fluid">
          <div className="row PM-plan-borde-spacing">
            <div className="col-md-12 text-center PM-tipo-denuncias-select">
              <div className="row col-md-12 text-center">
                <div className="PM-section-title col-md-12 text-center">Encuesta del Trabajador</div>
                <div className="col-md-12 text-center">
                  <h5>Para aquellos trabajadores que no tengan acceso a correo electrónico y/o computador, se deberá facilitar un computador o tablet para que puedan responder. Nadie puede quedar fuera.</h5>
                </div>
              </div>
            </div>
            <div className="col-md-12 text-center PM-plan-contador-tareas PM-home-item-plan">
              <ul>
                <li className="PM-border-line">
                  <div className="row">
                    <div className="col-sm-9 text-left">
                      <div className="PM-cuadro-3">
                        <h5><strong>Crear la encuesta a trabajadores.</strong></h5>
                        <p>Configura la encuesta ingresando la cantidad de hombres y mujeres que trabajan en el centro de trabajo, junto con la fecha de cierre de la encuesta (recomendamos máximo 2 semanas).</p>
                        <p>Si no se ha cumplido con el 60% de respuestas deberás modificar la fecha de cierre.</p>
                        <div className="row">
                          <div className="col-sm-9" style={{ paddingRight: 0 }}>
                            <TextField
                              id="url_encuesta_trabajador"
                              label="Url Encuesta Trabajador"
                              maxLength={1000}
                              disabled
                              value={(this.props.estadoTokenEncuesta) ? `${apiConfig.linkEncuestasMovilidad}/${this.props.idtokenEncuesta}` : null}
                            />
                          </div>
                          <div className="col-sm-3" style={{ padding: 0, marginTop: 48 }}>
                            <button
                              className="btn PM-dx-button-plan PM-dx-button-plan-100 PM-button-light"
                              onClick={this.prepareCopyToClipboard}
                              disabled={!this.props.estadoTokenEncuesta}
                            >Copiar</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-3 PM-btn-material">
                      <button
                        style={{ margin: 2 }}
                        className="btn PM-dx-button-plan PM-dx-button-plan-100 PM-button-light"
                        onClick={this.onClickOpenModal}
                        disabled={ !this.props.esEncargado }
                      >{this.props.estadoTokenEncuesta ? "Editar encuesta" : "Habilitar encuesta"}
                      </button>
                    </div>
                  </div>
                </li>
                <li className="PM-border-line">
                  <div className="row">
                    <div className="col-sm-5 text-left">
                      <div className="PM-cuadro-3">
                        <h5><strong>Seguimiento Encuesta</strong></h5>
                        <span>
                          <TextField
                            id="encuestaHombresActual"
                            label="Cantidad de encuestas de hombres:"
                            disabled
                            value={this.props.encuestaHombres.toString()}
                          />
                        </span>
                        <span style={{ paddingTop: 3, paddingLeft: 15 }}>Respuestas: {porcentajesEncuestasTrabajadores(this.props.encuestaHombres,this.props.cantidadHombresCentro)}%</span>
                      </div>
                    </div>
                    <div className="col-sm-4 text-left" style={{ marginTop: 27 }}>
                      <div className="PM-cuadro-3">
                        <span>
                          <TextField
                            id="encuestaMujeresActual"
                            label="Cantidad de encuestas de mujeres:"
                            disabled
                            value={this.props.encuestaMujeres.toString()}
                          />
                        </span>
                        <span style={{ paddingTop: 3, paddingLeft: 15 }}>Respuestas: {porcentajesEncuestasTrabajadores(this.props.encuestaMujeres,this.props.cantidadMujeresCentro)}%</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="PM-border-line">
                  <div className="row">
                    <div className="col-sm-9 text-left">
                      <div className="PM-cuadro-3">
                        <h5><strong>¡Termina la encuesta!</strong></h5>
                        <p>Si ya cumpliste con la cantidad de encuestas que querías realizar, no esperes más y finalízala aquí!</p>  
                      </div>
                    </div>
                    <div className="col-sm-3 PM-btn-material">
                      <button
                        style={{ margin: 2 }}
                        className="btn PM-dx-button-plan PM-dx-button-plan-100 PM-button-light"
                        onClick={this.onClickCloseQuestionary}
                        disabled={ !this.props.estadoTokenEncuesta || !this.props.esEncargado }
                      >Finalizar encuesta
                      </button>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="container-fluid PM-btn-box">
          <div className="text-center PM-plan-contador-finalizar PM-button-cierre">
            <button
              className="btn PM-dx-button-plan PM-dx-button-plan-100 PM-dx-button-plan-aire"
              onClick={() => {
                this.props.dispatch(loadSubMenu(0, 0));
              }}
            >Volver
            </button>
          </div>
        </div>
        <div className="PM-footer">&nbsp;</div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  idtokenEncuesta: state.planMovilidad.idtokenEncuesta,
  usuarioRUT: state.global.userData.RUT,
  usuarioNombre: state.global.userData.FirstName,
  usuarioApellido: state.global.userData.LastName,
  idplanMovilidad: state.planMovilidad.idplanMovilidad,
  habilitarTokenEncuesta: state.planMovilidad.habilitarTokenEncuesta,
  estadoTokenEncuesta: state.planMovilidad.estadoTokenEncuesta,
  encuestaHombres: state.planMovilidad.encuestaHombres,
  encuestaMujeres: state.planMovilidad.encuestaMujeres,
  cantidadHombresCentro: state.planMovilidad.cantidadHombresCentro,
  cantidadMujeresCentro: state.planMovilidad.cantidadMujeresCentro,
  fechaCierreEncuestaTrabajador: state.planMovilidad.fechaCierreEncuestaTrabajador,
  esEncargado: state.planMovilidad.esEncargado,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(EncuestaTrabajadorPlanMovilidad);
